"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeModule = void 0;
const constants_1 = require("../constants");
const query_options_1 = require("../types/query-options");
const common_1 = require("./common");
const node_1 = require("./service/node");
class NodeModule {
    constructor(wallet, api, nodeType, objectType, service) {
        this.defaultListOptions = {
            shouldDecrypt: true,
            parentId: undefined,
            filter: {
                status: { ne: constants_1.status.REVOKED },
                and: {
                    status: { ne: constants_1.status.DELETED }
                }
            }
        };
        this.defaultGetOptions = {
            shouldDecrypt: true,
        };
        this.defaultCreateOptions = {
            parentId: undefined,
            tags: [],
            arweaveTags: [],
        };
        this.service = new node_1.NodeService(wallet, api, nodeType, objectType, service);
        this.objectType = objectType;
    }
    /**
     * @param  {string} nodeId
     * @returns Promise with the decrypted node
     */
    get(nodeId, options = this.defaultGetOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const getOptions = Object.assign(Object.assign({}, this.defaultGetOptions), options);
            const nodeProto = yield this.service.api.getNode(nodeId, this.objectType, getOptions.vaultId);
            const node = yield this.service.processNode(nodeProto, !nodeProto.__public__ && getOptions.shouldDecrypt, nodeProto.__keys__);
            return node;
        });
    }
    /**
     * @param  {string} vaultId
     * @param  {ListOptions} options
     * @returns Promise with paginated nodes within given vault
     */
    list(vaultId, options = this.defaultListOptions = this.defaultListOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, query_options_1.validateListPaginatedApiOptions)(options);
            const listOptions = Object.assign(Object.assign({}, this.defaultListOptions), options);
            const response = yield this.service.api.getNodesByVaultId(vaultId, this.objectType, listOptions);
            const items = [];
            const errors = [];
            const processItem = (nodeProto) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const node = yield this.service.processNode(nodeProto, !nodeProto.__public__ && listOptions.shouldDecrypt, nodeProto.__keys__);
                    items.push(node);
                }
                catch (error) {
                    errors.push({ id: nodeProto.id, error });
                }
                ;
            });
            yield (0, common_1.processListItems)(response.items, processItem);
            return {
                items,
                nextToken: response.nextToken,
                errors
            };
        });
    }
    /**
     * @param  {string} vaultId
     * @param  {ListOptions} options
     * @returns Promise with all nodes within given vault
     */
    listAll(vaultId, options = this.defaultListOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const list = (options) => __awaiter(this, void 0, void 0, function* () {
                return yield this.list(options.vaultId, options);
            });
            return yield (0, common_1.paginate)(list, Object.assign(Object.assign({}, options), { vaultId }));
        });
    }
    /**
     * @param  {string} nodeId
     * @param  {string} name new name
     * @returns Promise with corresponding transaction id
     */
    rename(nodeId, name) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.service.setVaultContextFromNodeId(nodeId, this.objectType);
            this.service.setActionRef(this.objectType.toUpperCase() + "_RENAME");
            this.service.setFunction(constants_1.functions.NODE_UPDATE);
            const state = {
                name: yield this.service.processWriteString(name)
            };
            return this.service.nodeUpdate(state);
        });
    }
    /**
     * @param  {string} nodeId
     * @param  {string} [parentId] new parent folder id
     * @returns Promise with corresponding transaction id
     */
    move(nodeId, parentId, vaultId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.service.setVaultContextFromNodeId(nodeId, this.objectType, vaultId);
            this.service.setActionRef(this.objectType.toUpperCase() + "_MOVE");
            this.service.setFunction(constants_1.functions.NODE_MOVE);
            return this.service.nodeUpdate(null, { parentId });
        });
    }
    /**
     * @param  {string} nodeId
     * @returns Promise with corresponding transaction id
     */
    revoke(nodeId, vaultId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.service.setVaultContextFromNodeId(nodeId, this.objectType, vaultId);
            this.service.setActionRef(this.objectType.toUpperCase() + "_REVOKE");
            this.service.setFunction(constants_1.functions.NODE_REVOKE);
            return this.service.nodeUpdate();
        });
    }
    /**
     * @param  {string} nodeId
     * @returns Promise with corresponding transaction id
     */
    restore(nodeId, vaultId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.service.setVaultContextFromNodeId(nodeId, this.objectType, vaultId);
            this.service.setActionRef(this.objectType.toUpperCase() + "_RESTORE");
            this.service.setFunction(constants_1.functions.NODE_RESTORE);
            return this.service.nodeUpdate();
        });
    }
    /**
     * @param  {string} nodeId
     * @returns Promise with corresponding transaction id
     */
    delete(nodeId, vaultId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.service.setVaultContextFromNodeId(nodeId, this.objectType, vaultId);
            this.service.setActionRef(this.objectType.toUpperCase() + "_DELETE");
            this.service.setFunction(constants_1.functions.NODE_DELETE);
            return this.service.nodeUpdate();
        });
    }
}
exports.NodeModule = NodeModule;
